<div role="alert" [ngClass]='"alert alert-" + type + (closable ? " alert-alert-dismissible" : "")' [ngStyle]="withoutIcon ? { backgroundImage: 'none', paddingLeft: '.875rem' } : null">
  <strong *ngIf='alertTitle as title'>{{ title }}</strong>
  {{ content }}
  <ng-content></ng-content>
  <button *ngIf='closable' type='button' aria-label='Zamknij' (click)='onClose.emit()'>
    <span aria-hidden='true'>&times;</span>
  </button>
</div>
